export default __webpack_public_path__ + "static/media/thumbnail.a104037f.webp";